import {signal} from '@/script/signal'
import http from './http'

const [dbmsTypes, useDbmsTypes] = signal([])
export {dbmsTypes, useDbmsTypes}

const init = async () => {
    const items = await http.get('/dbmsType/listEnableDbmsType')
    dbmsTypes.value = items.map(e => [e.code, e.name])
}

init()
